import type { EditorElement, EditorPluginOptions, EditorPluginPropertyOptions } from '../../types';
import type { ComponentType } from 'react';

export const PARAGRAPH_PLUGIN_ID = 'paragraph' as const;
export type ParagraphPluginID = typeof PARAGRAPH_PLUGIN_ID;

export const PARAGRAPH_LIST_ITEM_VARIANT = 'li';
type ParagraphVariant = typeof PARAGRAPH_LIST_ITEM_VARIANT;

export type ParagraphPluginElement = Readonly<
  EditorElement & {
    type: ParagraphPluginID;
    variant?: ParagraphVariant;
    shouldForceInline?: boolean;
  }
>;

export type ParagraphPluginElementMutable = ParagraphPluginElement;

export type ParagraphPluginOptions = Readonly<
  EditorPluginOptions & {
    component?: ComponentType<any>;
    allowNewLines?: boolean;
  }
>;

export type ParagraphPluginPropertyOptions = Readonly<
  EditorPluginPropertyOptions &
    ParagraphPluginOptions & {
      pluginID: ParagraphPluginID;
      component: ComponentType<any>;
      pluginName: string;
    }
>;
